<template>
  <div class="mySubscribe-notice">
    <div class="page-manage page-manage-evaluation-config">
      <customize-form
        class="myform"
        :form-config="formConfig"
        @on-query="onQuery"
        @on-reset="onReset"
      ></customize-form>
      <customize-table
        v-loading="loading"
        :table-config="tableConfig"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :currentPage.sync="params.pageNum"
      >
        <template v-slot:code="{ column }">
          <el-table-column v-bind="column">
            <template v-slot="scope">
              <span class="cell-link" @click="clickCode(scope.row)">{{
                scope.row.code
              }}</span>
            </template>
          </el-table-column>
        </template>
      </customize-table>
    </div>
  </div>
</template>
<script>
import { daterange } from '@/utils/constantime'
export default {
  name: 'MySubscribeNotice',
  data() {
    return {
      removeV: 1,
      formConfig: {
        configs: {
          title: {
            tag: 'input',
            label: '公告标题'
          },
          compName: {
            tag: 'input',
            label: '公告单位'
          },
          noticeDate: {
            ...daterange,
            label: '公告发布日期'
          },
          proviceCode: {
            tag: 'select',
            label: '所在省市',
            default: null,
            options: []
          },
          biddingCodeCode: {
            tag: 'select',
            label: '状态',
            default: null,
            options: [
              { value: 0, label: '竞价未开始' },
              { value: 1, label: '竞价中' },
              { value: 2, label: '竞价已结束' }
            ]
          },
          biddingDate: {
            ...daterange,
            label: '竞价开始日期'
          }
        },
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      tableConfig: {
        isPagination: true,
        columns: [
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center'
          },
          {
            prop: 'code',
            slot: 'code',
            'show-overflow-tooltip': true,
            label: '公告编号',
            align: 'center',
            width: '140px'
          },
          {
            prop: 'title',
            label: '公告标题',
            'show-overflow-tooltip': true,
            // width: '100px',
            align: 'center'
          },
          {
            prop: 'compName',
            label: '发布单位',
            'show-overflow-tooltip': true,
            // width: '100px',
            align: 'center'
          },
          {
            // slot: 'location',
            prop: 'proviceName',
            label: '所在省市',
            align: 'center'
            // width: '120px'
          },
          {
            prop: 'publishTime',
            label: '发布时间',
            align: 'center',
            // width: '100px',
            'show-overflow-tooltip': true
          },
          {
            prop: 'bidStartTime',
            'show-overflow-tooltip': true,
            label: '竞价开始时间',
            // width: '150px',
            align: 'center'
          },
          {
            prop: 'scheduleView',
            // slot: 'scheduleCode',
            label: '状态',
            // width: '150px',
            align: 'center'
          }
        ],
        data: [],
        total: 0
      },
      params: {
        pageNum: 1,
        pageSize: 10
      },
      loading: false
    }
  },
  created() {
    if (!localStorage.getItem('mobile')) {
      this.getUserInfos()
    }
    this.getCity()
    this.getLists()
  },
  methods: {
    async getUserInfos() {
      const { mobile } = await this.$api.mySubscribe.getUserInfo()
      localStorage.setItem('mobile', mobile)
    },
    async getCity() {
      const citys = await this.$api.mySubscribe.getProvices({
        classCode: 'COUNTRYREGIONSANDPROVINCES',
        higherCode: 148
      })
      const data = await this.$api.mySubscribe.getSubscribe()
      if (data.provinceIds) {
        const arr = data.provinceIds.split(',')
        const citysArr = []
        arr.map(element => {
          const obj = citys.data.find(item => item.codeCode === element)
          obj &&
            citysArr.push({
              ...obj,
              label: obj.codeName,
              value: obj.codeCode
            })
        })
        this.formConfig.configs.proviceCode.options = citysArr
      }
    },
    remove(val) {
      this.removeV = val
    },
    clickCode(obj) {
      this.$router.push(`/home/noticeInfo?id=${obj.id}`)
    },
    onQuery(val) {
      if (val.noticeDate) {
        val.publishStartTime = val.noticeDate[0]
        val.publishEndTime = val.noticeDate[1]
      }
      if (val.biddingDate) {
        val.bidStartTimeStr = val.biddingDate[0]
        val.bidEndTimeStr = val.biddingDate[1]
      }
      this.params = {
        ...this.params,
        bidStartTimeStr: val.bidStartTimeStr,
        bidEndTimeStr: val.bidEndTimeStr,
        publishEndTime: val.publishEndTime,
        publishStartTime: val.publishStartTime,
        title: val.title,
        proviceCode: val.proviceCode,
        biddingCodeCode: val.biddingCodeCode,
        compName: val.compName
      }
      this.getLists()
    },
    onReset() {
      this.params = {
        pageNum: 1,
        pageSize: 10
      }
      this.getLists()
    },
    async getLists() {
      this.loading = true
      let obj = {
        ...this.params
      }
      let data = await this.$api.mySubscribe.getList(obj)
      this.loading = false
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageNum: val,
        pageSize: 10
      }
      this.getLists()
    },
    onSizeChange(val) {
      this.params = {
        ...this.params,
        pageNum: 1,
        pageSize: val
      }
      this.getLists()
    }
  }
}
</script>
<style lang="less" scoped>
.mySubscribe-notice {
  .myform /deep/ .el-input .el-input__inner {
    width: 160px;
  }

  /deep/ .customize-form .el-form-item__label {
    min-width: 70px;
  }
  /deep/ .more {
    position: unset;
    width: auto;
  }
}
</style>
